import { useEffect } from 'react';
import { useState } from 'react';
import { useSelector } from 'react-redux';

import { toast } from 'react-toastify';
import { createPaymentAction, updatePaymentAction } from './API/Action';
import { Box, InputAdornment, Typography } from '@mui/material';
import { CustomButton, TextField } from '../../v2/MUI_custom_component';
import { CurrencyRupeeOutlined } from '@mui/icons-material';

export default function CreatePayment({ onPaymentSuccess, onPaymentFailed, onPaymentPending }) {
  const {
    selectedEntity: selectedCompanyEntity,
    selectedSupplier: selectedManufacturer,
    selectedSupplierData,
  } = useSelector((state) => state.entityReducer);
  const [amount, setAmount] = useState(null);
  const [loading, setLoading] = useState(false);

  const updateStatus = async (txnid) => {
    await updatePaymentAction({
      txnid: String(txnid),
    });
  };


  // function for calling payment window
  const paymentProcedure = async ({ error, message, data }) => {
    if (error) {
      toast.error(message);
      return;
    }
    const paymentModeBillDesk = () => {
      const form = document.createElement('form');
      form.name = 'Billdesk';
      form.method = 'POST';
      form.action = process.env.REACT_APP_BILLDESK_CHECKOUT_URL;
      const payloadField = document.createElement('input');
      payloadField.type = 'hidden';
      payloadField.name = 'msg';
      payloadField.value = data.msg;
      form.appendChild(payloadField);
      document.body.appendChild(form);
      form.submit();
    };

    const paymentModeEaseBuzz = () => {
      const EasebuzzCheckout = window.EasebuzzCheckout;

      var easebuzzCheckout = new EasebuzzCheckout(
        process.env.REACT_APP_EASEBUZZ_KEY,
        process.env.REACT_APP_EASEBUZZ_ENV,
      );
      var options = {
        access_key: data.access_key, // access key received via Initiate Payment
        onResponse: (response) => {
          if (response.status === 'success') {
            setAmount('');
            onPaymentSuccess?.();
            updateStatus(response.txnid);
          } else if (response.status === 'pending' || response.status === 'dropped') {
            setAmount('');
            onPaymentPending?.();
            updateStatus(response.txnid);
          } else {
            // userCancelled, failure, failed
            setAmount('');
            onPaymentFailed?.();
            updateStatus(response.txnid);
          }
        },
        theme: '#F49D3F', // color hex
      };
      easebuzzCheckout.initiatePayment(options);
    };
    data && data.msg ? paymentModeBillDesk() : paymentModeEaseBuzz();
  };

  // Injecting EasebuzzCheckout object
  useEffect(() => {
    const script = document.createElement('script');

    script.src =
      'https://ebz-static.s3.ap-south-1.amazonaws.com/easecheckout/v2.0.0/easebuzz-checkout-v2.min.js';
    script.async = true;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const onFinish = async () => {
    if (!amount) {
      return toast.error('Please enter a valid amount');
    }

    setLoading(true);
    let payload = {
      manufacturer_id: selectedManufacturer,
      amount: amount,
      advance: true,
      return_url: process.env.REACT_APP_BILLDESK_RETURN_URL,
      buyer_esi_id: selectedCompanyEntity,
    };
    const response = await createPaymentAction(payload);

    setLoading(false);

    paymentProcedure(response);
  };

  return (
    <>
      <Box
        sx={{
          p: 2,
          background: '#fff',
          borderRadius: 2,
          display: 'flex',
          flexDirection: 'column',
          gap: 1,
        }}
      >
        <Typography variant='h2'>Payment</Typography>
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Typography
            variant='labelD'
            sx={{ color: '#666' }}
          >
            Manufacturer
          </Typography>
          <Typography variant='body1'>{selectedSupplierData?.name}</Typography>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
          }}
        >
          <TextField
            placeholder='Enter amount'
            variant='outlined'
            fullWidth
            label={`Amount`}
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            type='number'
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment position='start'>
                    <CurrencyRupeeOutlined
                      width={20}
                      height={20}
                    />
                  </InputAdornment>
                ),
              },
            }}
          />
          <CustomButton
            variant='filled'
            color='primary'
            label='Pay'
            onClick={() => onFinish()}
            loading={loading}
            disabled={!amount || loading}
          />
        </Box>
      </Box>
    </>
  );
}
